
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/home/benefits-section.kpa`,
      template: `<section class="benefits-section">
        <div class="wrapper">
            <div class="card box-shadow" data-navigate="/ueberuns/fachkompetenz">
                <div class="emblem">
                    {{ createHexSvg }}
                    <img class="icon" src="/images/thinking.png" alt="Fachkompetenz">
                </div>
                
                <h1 class="text-shadow-small">Fachkompetenz</h1>

                <p>
                    Unsere überdurchschnittliche <b>Fachkompetenz</b> und langjährige <b>Erfahrung</b> stellt einen enormen <b>Wettbewerbsvorteil</b> dar.
                </p> 
            </div>

            <div class="card box-shadow" data-navigate="/ueberuns/infrastruktur">
                <div class="emblem">
                    {{ createHexSvg }}
                    <img class="icon" src="/images/network.png" alt="Infrastruktur">
                </div>

                <h1 class="text-shadow-small">Infrastruktur</h1>

                <p>
                    Durch unser riesiges <b>Netzwerk</b> sind wir in der Lage, auf alle <b>Bedürfnisse</b> Ihrer <b>Immobilie</b> einzugehen.
                </p> 
            </div>

            <div class="card box-shadow" data-navigate="/ueberuns/automatisierung">
                <div class="emblem">
                    {{ createHexSvg }}
                    <img class="icon" src="/images/robotics.png" alt="Automatisierung">
                </div>

                <h1 class="text-shadow-small">Automatisierung</h1>

                <p>
                    Unsere automatisierten <b>Wartungsprozesse</b> ermöglichen eine effiziente <b>Problembehebung</b>.
                </p> 
            </div>

            <div class="card box-shadow" data-navigate="/ueberuns/objektakte">
                <div class="emblem">
                    {{ createHexSvg }}
                    <img class="icon" src="/images/files.png" alt="Digitale Objektakte">
                </div>

                <h1 class="text-shadow-small">Objektakte</h1>

                <p>
                    Durch unsere digitale <b>Objektakte</b> werden alle <b>Maßnahmen</b> langfristig <b>dokumentiert</b>.
                </p> 
            </div>
        </div>
    </section>`,
      style: `benefits-section .benefits-section {
  position: relative;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  max-width: 100%;
  padding: 0 64px;
  margin-top: 0;
  margin-bottom: -164px;
  background: linear-gradient(to bottom, #64c16c 0 calc(100% - 164px), #f2f2f1 calc(100% - 164px));
}
benefits-section .benefits-section .wrapper {
  padding: 0;
  position: relative;
  top: -32px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  max-width: 1440px;
}
benefits-section .benefits-section .wrapper .card {
  position: relative;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 86px 16px 16px 16px;
  margin-bottom: 100px;
  cursor: pointer;
}
benefits-section .benefits-section .wrapper .card .emblem {
  position: absolute;
  top: -70px;
  width: 140px;
  height: 140px;
  /* white-green */
  /* white-gray */
  /* gray-green */
  /* green-gray */
}
benefits-section .benefits-section .wrapper .card .emblem .hex {
  position: absolute;
  top: 50%;
  left: calc(50% - 0.35px);
  width: auto;
  height: 113%;
  transform: translate(-50%, -50%);
}
benefits-section .benefits-section .wrapper .card .emblem .hex path.stroke-color {
  transition: stroke 0.3s ease;
}
benefits-section .benefits-section .wrapper .card .emblem .hex path.fill-color {
  transition: fill 0.3s ease;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v1 path.stroke-color {
  stroke: #ffffff;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v1 path.fill-color {
  fill: #64c16c;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v2 path.stroke-color {
  stroke: #ffffff;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v2 path.fill-color {
  fill: #2c4143;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v3 path.stroke-color {
  stroke: #2c4143;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v3 path.fill-color {
  fill: #64c16c;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v4 path.stroke-color {
  stroke: #64c16c;
}
benefits-section .benefits-section .wrapper .card .emblem .hex.v4 path.fill-color {
  fill: #2c4143;
}
benefits-section .benefits-section .wrapper .card .emblem .icon {
  position: absolute;
  top: 20%;
  left: 20%;
  width: 60%;
  height: auto;
  filter: invert(1);
}
benefits-section .benefits-section .wrapper .card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  /* white-green */
  /* white-gray */
  /* gray-green */
  /* green-gray */
}
benefits-section .benefits-section .wrapper .card:hover .hex path.stroke-color {
  transition: stroke 0.3s ease;
}
benefits-section .benefits-section .wrapper .card:hover .hex path.fill-color {
  transition: fill 0.3s ease;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v1 path.stroke-color {
  stroke: #ffffff;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v1 path.fill-color {
  fill: #2c4143;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v2 path.stroke-color {
  stroke: #ffffff;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v2 path.fill-color {
  fill: #64c16c;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v3 path.stroke-color {
  stroke: #64c16c;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v3 path.fill-color {
  fill: #2c4143;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v4 path.stroke-color {
  stroke: #2c4143;
}
benefits-section .benefits-section .wrapper .card:hover .hex.v4 path.fill-color {
  fill: #64c16c;
}
benefits-section .benefits-section .wrapper .card h1 {
  font-size: 1.5rem;
  margin: 16px 0 16px 0;
  color: var(--accent-color);
}
benefits-section .benefits-section .wrapper .card p {
  font-size: 1rem;
  margin: 0;
}
@media (max-width: 992px) {
  benefits-section .benefits-section {
    padding: 0 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    methods: {
        createHexSvg() {
            return \`
                <svg class="hex v1" width="100%" height="100%" viewBox="0 0 134 154" version="1.1" 
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                    xml:space="preserve" xmlns:serif="http://www.serif.com/" 
                    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1;" 
                    overflow="visible">
                    <defs>
                        <filter id="hex-shadow" x="-20%" y="-20%" width="140%" height="140%">
                            <!-- Schatten-Effekt -->
                            <feDropShadow dx="0" dy="6" stdDeviation="4" flood-color="rgba(0, 0, 0, 0.5)" />
                        </filter>
                    </defs>
                    <g transform="matrix(1,0,0,1,-1654,-1142)">
                        <!-- Außenkontur -->
                        <path class="stroke-color" d="M1721.33,1149L1781.67,1184L1781.67,1254L1721.33,1289L1661,1254L1661,1184L1721.33,1149Z" 
                            style="fill:none;stroke-width:18px;filter:url(#hex-shadow);"
                        />

                        <!-- Gefülltes Polygon -->
                        <path class="fill-color" d="M1721.33,1149L1781.67,1184L1781.67,1254L1721.33,1289L1661,1254L1661,1184L1721.33,1149Z" />
                    </g>
                </svg>
                \`;
        }
    },
    events: [
        ['click', '[data-navigate]', function (event) {
                event.preventDefault();
                router.navigate(event.target.closest('[data-navigate]').getAttribute('data-navigate'));
            }],
    ],
};
 })()`
    };
  